import * as React from "react";
import {
  CheckCircle,
  Receipt,
  CircleDashed,
  Warning,
  XCircle,
  PaperPlaneTilt,
} from "@phosphor-icons/react";
import { cn } from "@/lib/utils";
import type { InvoiceStatus, InvoiceLabels } from "./types";
import { statusColor } from "./utils";

interface Props {
  status: InvoiceStatus;
  labels: InvoiceLabels;
  size?: "sm" | "md";
  className?: string;
}

type IconType = React.ComponentType<{
  size?: number | string;
  weight?: "thin" | "light" | "regular" | "bold" | "fill" | "duotone";
  className?: string;
}>;

const ICON_FOR: Record<InvoiceStatus, IconType> = {
  paid: CheckCircle,
  issued: Receipt,
  sent: PaperPlaneTilt,
  draft: CircleDashed,
  voided: XCircle,
  failed: Warning,
};

export function InvoiceStatusChip({ status, labels, size = "md", className }: Props) {
  const colors = statusColor(status);
  const Icon = ICON_FOR[status];
  const px = size === "sm" ? "px-2 h-6 text-[11px]" : "px-2.5 h-7 text-xs";
  return (
    <span
      role="status"
      aria-label={labels.status[status]}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border font-semibold whitespace-nowrap",
        px,
        colors.bg,
        colors.fg,
        colors.border,
        status === "voided" && "line-through",
        className,
      )}
    >
      <Icon size={size === "sm" ? 12 : 14} weight={status === "draft" ? "regular" : "fill"} />
      <span>{labels.status[status]}</span>
    </span>
  );
}
